import {
  ARTIFACT_COOKIE_NAME,
  BRANCH_PREFIX,
  SET_BRANCH,
  SET_TAG,
  TAG_PREFIX
} from 'common/constants/constants';
import { omitFromQs } from 'common/utils/utils';
import Cookies from 'js-cookie';
import QueryString from 'query-string';

export const extractReleavantParams = () => {
  const qsParams = QueryString.parse(window.location.search);
  const branchParam = qsParams[SET_BRANCH];
  const tagParam = qsParams[SET_TAG];
  return { branchParam, tagParam };
};

export const shouldChangeEnvOrArtifact = ({ branchParam, tagParam }) => {
  const isRemoteDevEnv = window.location.hostname.includes('dev-');
  const isLocalhost = window.location.hostname.includes('localhost');

  return !!((isRemoteDevEnv || isLocalhost) && (tagParam || branchParam));
};

export const setRelevantCookies = ({ branchParam, tagParam }) => {
  if (branchParam) {
    Cookies.set(ARTIFACT_COOKIE_NAME, `${BRANCH_PREFIX}${branchParam}`, {
      expires: 365
    });
  } else if (tagParam) {
    Cookies.set(ARTIFACT_COOKIE_NAME, `${TAG_PREFIX}${tagParam}`, {
      expires: 365
    });
  }
};

const omitFromUrl = () => {
  omitFromQs(SET_BRANCH);
  omitFromQs(SET_TAG);
};

export const modifyBranchEnv = () => {
  const { branchParam, tagParam } = extractReleavantParams();

  if (!shouldChangeEnvOrArtifact({ branchParam, tagParam })) {
    return;
  }

  setRelevantCookies({ branchParam, tagParam });

  omitFromUrl();

  window.location.reload();
};
